import { cn } from '@avanta/shared/utils/cn';
import { type ReactElement } from 'react';
import { ColorByScore, TOTAL_SEGMENTS } from 'pages/Pae/components/BarometerResults/types';

export const Battery = ({
  score,
  maxScore,
  className,
}: {
  score: number;
  maxScore: number;
  className?: string;
}): ReactElement => {
  const clampedLevel = Math.min(Math.max(score, 0), maxScore);
  const filledSegments = maxScore > 0 ? Math.ceil((clampedLevel / maxScore) * TOTAL_SEGMENTS) : 0;
  const segmentsColors = Object.values(ColorByScore);
  return (
    <div className={cn('inline-flex h-22 w-10 flex-col am-xl:h-31 am-xl:w-14', className)}>
      <div className="mx-auto h-1 w-4 rounded-t-sm bg-denim-900 am-xl:w-5" />
      <div className="flex h-full w-full flex-col gap-0.5 overflow-hidden rounded-lg border-4 border-denim-900 p-0.5 am-xl:gap-1 am-xl:p-1">
        {segmentsColors.map((_, index) => {
          const reversedIndex = segmentsColors.length - index - 1;
          const isFilled = reversedIndex < filledSegments;
          const segmentColor = isFilled ? segmentsColors[reversedIndex] : 'bg-background';
          return (
            <div key={index} className={cn('flex-1 transition-all duration-300', segmentColor)} />
          );
        })}
      </div>
    </div>
  );
};
